import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import * as moment from 'moment';

/**
 * Generated class for the LoadimportedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-loadimported',
  templateUrl: 'loadimported.html',
})
export class LoadimportedPage {

  Data = []
  _selectedRouteId = 0
  _title = '';
  loadingData: boolean = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad LoadimportedPage');
    this.loadData()
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }

  loadData() {
    this._title = this.dic.l["downloadWorkOrder"]
    this.loadingData = true

    var _that = this
    this.gn._Post('/api/gn/getrouteindoor', { today: this.gn.crypt(false), cid: this.gn.crypt(this.gn.user.ClientId), status: this.gn.crypt(0) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        _data[i].datumcreate = moment(_data[i].dt_create).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].dt_create).format(_that.gn.user.TFormat)
        _data[i].datum = moment(_data[i].dt).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].dt).format(_that.gn.user.TFormat)
        _data[i].visible = true
        _data[i].datum = moment(_data[i].dt).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].dt).format(_that.gn.user.TFormat)
        _that.Data.push(_data[i])
      }
      _that.loadingData = false
      //debugger;
    })
  }

  loadImported() {
    var cb = this.navParams.get('cb')
    cb(this._selectedRouteId)
    this.navCtrl.pop()
  }


  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }    
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.Data.length; i++) {
      if (val == '') {
        this.Data[i].visible = true
      } else {
        var itm = this.Data[i].title.toLowerCase()
        var itm1 = this.Data[i].article.toLowerCase()
        var itm3 = ''
        if (this.Data[i].kreiral != null)
          itm3 = this.Data[i].kreiral.toLowerCase()
        var itm4 = ''
        if (this.Data[i].komentar != null)
          itm4 = this.Data[i].komentar.toLowerCase()

        if (this.gn._latcyr(itm).indexOf(val) > -1 || this.gn._cyrlat(itm).indexOf(val) > -1 ||
          this.gn._latcyr(itm1).indexOf(val) > -1 || this.gn._cyrlat(itm1).indexOf(val) > -1 ||
          this.gn._latcyr(itm3).indexOf(val) > -1 || this.gn._cyrlat(itm3).indexOf(val) > -1 ||
          this.gn._latcyr(itm4).indexOf(val) > -1 || this.gn._cyrlat(itm4).indexOf(val) > -1) {
          this.Data[i].visible = true
        } else {
          this.Data[i].visible = false
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/loadimported/loadimported.ts